var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.headerActionConfig,
          "left-side-class": "col-xl-4 pb-2",
          page: _vm.page,
          "right-side-class":
            "col-xl-8 align-items-end d-flex pb-4 justify-content-end"
        }
      }),
      _c("provider-search-filter", {
        staticClass: "mb-4",
        on: { search: _vm.handleSearch },
        model: {
          value: _vm.filter,
          callback: function($$v) {
            _vm.filter = $$v
          },
          expression: "filter"
        }
      }),
      _c("custom-separator", { attrs: { text: "Resultados" } }),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end" },
        [
          _c("action-button", {
            attrs: {
              i: _vm.orderIcon,
              text: "Ordenar por Nombre",
              variant: "success"
            },
            on: { click: _vm.orderByName }
          })
        ],
        1
      ),
      _c("provider-search-result", {
        attrs: { data: _vm.providers },
        on: {
          "page-changed": _vm.pageChanged,
          "per-page-changed": _vm.pageChanged
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }